import Navbar from "../Navbar";
import Footer from "../Footer";
import HeroSection, { HeroContent } from "./HeroSection";
import TrustBar from "./TrustBar";
import ServicesSection, { ServicesSectionContent } from "./ServicesSection";
import AIAnswerBlock, { AIBlockContent } from "./AIAnswerBlock";
import ProcessSection, { ProcessContent } from "./ProcessSection";
import WhyChooseUs, { WhyChooseContent } from "./WhyChooseUs";
import ServiceAreasSection, { ServiceAreasContent } from "./ServiceAreasSection";
import TestimonialsSection, { TestimonialsContent } from "./TestimonialsSection";
import FAQSection, { FAQContent } from "./FAQSection";
import FinalCTA, { FinalCTAContent } from "./FinalCTA";

export interface PageData {
  hero: HeroContent;
  services: ServicesSectionContent;
  aiBlock: AIBlockContent;
  process: ProcessContent;
  whyChoose: WhyChooseContent;
  serviceAreas: ServiceAreasContent;
  testimonials: TestimonialsContent;
  faq: FAQContent;
  finalCTA: FinalCTAContent;
}

interface Props {
  data: PageData;
}

export default function PageTemplate({ data }: Props) {
  return (
    <div className="min-h-screen">
      <Navbar />

      {/* 1. Hero */}
      <HeroSection content={data.hero} />

      {/* 2. Trust Bar */}
      <TrustBar />

      {/* 3. Services */}
      <ServicesSection content={data.services} />

      {/* 4. AI Answer Block */}
      <AIAnswerBlock content={data.aiBlock} />

      {/* 5. Process */}
      <ProcessSection content={data.process} />

      {/* 6. Why Choose Us */}
      <WhyChooseUs content={data.whyChoose} />

      {/* 7. Service Areas */}
      <ServiceAreasSection content={data.serviceAreas} />

      {/* 8. Testimonials */}
      <TestimonialsSection content={data.testimonials} />

      {/* 9. FAQ */}
      <FAQSection content={data.faq} />

      {/* 10. Final CTA */}
      <FinalCTA content={data.finalCTA} />

      <Footer />
    </div>
  );
}
